import defaultAvatar from 'assets/img/default-avatar.jpg'

class Utils {
  static getRoomUrl(item) {
    const createRoomHost = (e, n, t) => (e && /[^0-9]/.test(e) ? e : n && '0' != n ? n : 'yy/' + (e || t))

    const { roomId, yyid } = item
    return `https://www.huya.com/${createRoomHost(null, roomId, yyid)}`
  }


  static avatarErrorHandler(e) {
    e.target.src = defaultAvatar
  }

  static once(fn) {
    let result; let executed;

    return function () {
      if (!executed) {
        executed = true
        result = fn.apply(this, arguments)
      }

      return result
    }
  }

  static debounce(fn, delay, immediate) {
    let timer = null

    const debounced = function () {
      if (timer) clearTimeout(timer);

      const context = this
      const args = arguments

      if (immediate) {
        if (!timer) fn.apply(context, args);

        timer = setTimeout(() => {
          timer = null
        }, delay)
      } else {
        timer = setTimeout(() => {
          timer = null
          fn.apply(context, args)
        }, delay)
      }

      return context
    }

    debounced.cancel = function () {
      clearTimeout(timer)
      timer = null
    }

    return debounced
  }

  static throttle(fn, delay) {
    let firsTime = true
    let timer = null
    let args = null
    let context = null

    function throttled() {
      args = arguments
      context = this

      if (timer) {
        return
      }

      timer = setTimeout(() => {
        timer = null
        fn.apply(context, args)
        context = args = null
      }, firsTime ? 0 : delay)

      if (firsTime) firsTime = false;
    }

    throttled.cancel = function () {
      clearTimeout(timer)
      timer = context = args = null
    }

    return throttled
  }

  /*
     * @param {String} str 如： xxx=0&yyy=1&zzz=2
     * @return {Object}
     */
  static parseParam(str) {
    const list = (str + '').split('&')
    const param = {}

    list.forEach(item => {
      if (item) {
        const kv = item.split('=')

        if (kv[0]) {
          param[ decodeURIComponent(kv[0]) ] = decodeURIComponent(kv[1])
        }
      }
    })

    return param
  }

  static getCookie(name) {
    let result = ''
    const list = document.cookie.split('; ');

    list.forEach(item => {
      if (item) {
        const [key, val] = item.split('=')

        if (key == name) {
          result = val
        }
      }
    })

    return result
  }

  static formatDateTime(timestamp) {
    const date = new Date(timestamp * 1000)

    const year = date.getFullYear()
    const mon = date.getMonth() + 1
    const d = date.getDate()
    const h = date.getHours()
    const min = date.getMinutes()

    function toFixed(n) {
      return ('00' + n).slice((n + '').length)
    }

    return `${year}-${toFixed(mon)}-${toFixed(d)} ${toFixed(h)}:${toFixed(min)}`
  }
}

export default Utils;
